import React from "react";
import KaTeXComponent from "./KaTeXComponent";

// <img> tags are handled as strings, like the server does: re-serializing docx HTML through the DOM
// would rewrite it (the parser leaves text such as "a<b" unescaped).
export const IMG_TAG = /<img\b[^>]*>/gi;
const DOCX_REF = /\sdata-ref-key\s*=\s*(["']?)DOCX_\w+\1/i;
export const attrValue = (tag, name) => {
  const m = tag.match(new RegExp(`\\s${name}\\s*=\\s*(?:"([^"]*)"|'([^']*)'|([^\\s>]+))`, "i"));
  return m ? m[1] ?? m[2] ?? m[3] ?? "" : null;
};
export const isDocxImage = (tag) => DOCX_REF.test(tag);
// An image counts as content when it references a docx image or has a source (the server's rule).
const isContentImage = (tag) => isDocxImage(tag) || !!(attrValue(tag, "src") || "").trim();
// The server refuses inline image data (src or srcset) on tags without a docx reference.
export const hasForeignImage = (html) =>
  ((html || "").match(IMG_TAG) || []).some(
    (tag) => !isDocxImage(tag) && /data:/i.test(`${attrValue(tag, "src") || ""} ${attrValue(tag, "srcset") || ""}`)
  );

// contentEditable leaves "<br>" or "&nbsp;" behind when emptied: blank = no text and no content image.
export const isBlankHtml = (html) => {
  const s = html || "";
  if ((s.match(IMG_TAG) || []).some(isContentImage)) return false;
  return !s.replace(/<[^>]*>/g, "").replace(/&nbsp;|&#160;|\u00a0|\s/g, "");
};

// KaTeXComponent re-parses its HTML on every render and bodies can hold MBs of data-URI images,
// so rich text only re-renders when its HTML changes. `dollarMath={false}` for prose (passages):
// there "$5 and $10" are prices, and only \( \) and \[ \] delimit math.
export const RichText = React.memo(function RichText({ html, dollarMath = true }) {
  return <KaTeXComponent text={html || ""} dollarMath={dollarMath} />;
});
